import validate from "validate.js";

import moment from "moment";
import { getValidDate, toInt } from "./helpers/helpers";

validate.validators.isNotBlank = (value) =>
  value !== "" ? undefined : "is required";

validate.validators.isDateValid = (
  value,
  { excludeDay = false, keys = ["day", "month", "year"] },
  key,
  data
) => {
  const days = data[keys[0]] === "" && excludeDay ? 1 : data[keys[0]];
  const date = getValidDate(data[keys[2]], data[keys[1]], days);
  const isValid =
    date !== undefined &&
    date.getDate() === toInt(data[keys[0]]) &&
    date.getMonth() === toInt(data[keys[1]]) &&
    date.getFullYear() === toInt(data[keys[2]]);
  return isValid ? undefined : "needs to be a valid date";
};

validate.validators.isDateBefore = (
  value,
  { roundUpDay = false, date, keys = ["day", "month", "year"] },
  key,
  data
) => {
  if (value === "") {
    return undefined;
  }
  const daysInMonth = moment(
    getValidDate(data[keys[2]], data[keys[1]], 1)
  ).daysInMonth();
  const day = data[keys[0]] === "" && roundUpDay ? daysInMonth : data[keys[0]];
  const inputDate = getValidDate(data[keys[2]], data[keys[1]], day);
  const isUserInputBefore = inputDate < date;
  const isValidDate = inputDate !== undefined;
  // If not a valid date, pass this test as valid, (validators.isValid should test for date validity)
  if (isValidDate) {
    return isUserInputBefore ? undefined : "not before";
  }
  return undefined;
};

validate.validators.isValidTelephone = (value) => {
  const validTelephoneRegex =
    // eslint-disable-next-line no-useless-escape
    /^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/;
  return !value || validTelephoneRegex.test(value)
    ? undefined
    : "must be valid";
};

validate.validators.longerThanOrBlank = (value, { number, message }) => {
  const displayMessage = message || `must be larger than ${number} characters`;
  return !value || value.length > number ? undefined : displayMessage;
};

validate.validators.isAfter = (value, options, key, attributes) => {
  const { fromMonth, fromYear, toMonth, toYear } = attributes;

  const fromDate = getValidDate(fromYear, fromMonth, 1);
  const toDate = getValidDate(toYear, toMonth, 1);
  if (fromDate && toDate && fromDate <= toDate) {
    return undefined;
  }

  return "^End date must be after start date";
};

validate.validators.isValidPostcode = (value) => {
  const validPostcodeRegex = /^[A-Z]{1,2}[0-9]{1,2}[A-Z]?\s?[0-9][A-Z]{2}$/i;
  return !value || validPostcodeRegex.test(value) ? undefined : "must be valid";
};

export default validate;
